import React, { useState } from 'react';
import { CheckSquare, ArrowRight } from 'lucide-react';
import { ROLES } from './guideContent';
import { muted, primary } from './mbApi';

const Block = ({ title, children }) => (
  <div>
    <p className={`text-[11px] font-semibold uppercase tracking-wider ${primary} mb-1`}>{title}</p>
    {children}
  </div>
);

const RoleBody = ({ r }) => (
  <div className={`space-y-3 text-xs ${muted} leading-relaxed`} data-testid={`mb-role-guide-${r.key}`}>
    <p className={`text-sm font-semibold ${primary}`}>{r.title}</p>
    <Block title="Tugas pertama"><p>{r.first}</p></Block>
    <Block title="Laluan klik">
      <p className="flex flex-wrap items-center gap-1">
        {r.path.map((p, i) => (
          <React.Fragment key={p}>
            {i > 0 && <ArrowRight size={11} className="shrink-0" />}
            <span className={`px-1.5 py-0.5 rounded bg-white/5 ${primary}`}>{p}</span>
          </React.Fragment>
        ))}
      </p>
    </Block>
    {r.tips.length > 0 && <Block title="Perlu tahu"><ul className="list-disc pl-4 space-y-1">{r.tips.map((t) => <li key={t}>{t}</li>)}</ul></Block>}
    <Block title="Contoh input (contoh sahaja — tidak disimpan)">
      <ul className="space-y-0.5 border-l-2 border-[#F77F00]/40 pl-2 italic">{r.example.map((e) => <li key={e}>{e}</li>)}</ul>
    </Block>
    <Block title="Checklist siap">
      <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-0.5">{r.checklist.map((c) => <li key={c} className="flex items-center gap-1.5"><CheckSquare size={11} className="text-emerald-400 shrink-0" />{c}</li>)}</ul>
      <p className="mt-1">{r.checklistNote}</p>
    </Block>
    <Block title="Serah kepada"><p>{r.handoff}</p></Block>
    <Block title="Belajar dari hasil"><p>{r.learn}</p></Block>
    <p className="text-[10px] opacity-80">Panduan ini tidak menukar hak akses — butang yang muncul tetap ikut PIC/akses sebenar awak.</p>
  </div>
);

export const RoleGuide = () => {
  const [role, setRole] = useState('kaer');
  const r = ROLES.find((x) => x.key === role);
  return (
    <div className="space-y-3" data-testid="mb-role-guide">
      <div className="flex flex-wrap gap-1.5" role="tablist">
        {ROLES.map((x) => (
          <button key={x.key} onClick={() => setRole(x.key)} role="tab" aria-selected={role === x.key}
            className={`h-9 px-3 rounded-full text-xs font-medium border transition-colors ${role === x.key ? 'bg-[hsl(var(--primary))] text-white border-transparent' : `border-[hsl(var(--border))] ${muted} hover:text-[hsl(var(--text-primary))]`}`}
            data-testid={`mb-role-pick-${x.key}`}>{x.label}</button>
        ))}
      </div>
      <RoleBody r={r} />
    </div>
  );
};
